export const getGap = (isSmall: boolean) => {
  return isSmall ? 2 : 4
}

export const getFlexDirection = (isSmall: boolean) => {
  return isSmall ? 'column' : 'row'
}